/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import React, { Fragment, useState } from 'react';
import { AddButton } from '../AddButton';
import { TextField } from './TextField';
import GridRow from './GridRow';

export const GridTable = ({
  addNewItem,
  fieldArrayRenderProps,
  gridFields,
  searchPlaceholder,
  flattenFields,
  setEdit,
  fieldKey,
  input
}) => {
  const [search, setSearch] = useState('');

  const filterItems = (event) => {
    setSearch(event.target.value);
  };

  return (
    <Fragment>
      <div className='flex'>
        <div className='w-3/4'>
          <AddButton label='New plan' onClick={() => addNewItem(fieldArrayRenderProps.fields)} />
        </div>
        <div className='w-1/4'>
          <TextField
            name='search'
            placeholder={searchPlaceholder}
            onKeyUp={filterItems}
            // Right={icons[searchFieldIcon]} // TODO add appropriate icon here
          />
        </div>
      </div>
      <table className='w-full table-auto'>
        <thead>
          <tr className='uppercase border-b-2 border-primary-500 text-gray-30'>
            {gridFields?.map((fieldName) => {
              const label = flattenFields.find((item) => {
                return item.name === fieldName;
              })?.label;
              return (
                <th className='px-4 text-left' key={label}>
                  {label}
                </th>
              );
            })}
            <th className='w-20 px-4 py-2'>Action</th>
          </tr>
        </thead>
        <tbody>
          {fieldArrayRenderProps?.fields?.map((name, index) => {
            const values: string[] = input?.value[index]
              ? Object.keys(input.value[index]).map((key) => input.value[index][key])
              : [];

            const isFiltered = values.reduce<boolean>((acc, item) => {
              return (item && item.includes && item.includes(search)) || acc;
            }, false);

            if (!isFiltered) {
              return false;
            }
            return (
              <GridRow
                key={`${name || fieldKey}-${index}`}
                setEditMode={setEdit}
                fields={filterVisibleFields(gridFields, flattenFields)}
                name={name}
              />
            );
          })}
        </tbody>
      </table>
    </Fragment>
  );
};

function filterVisibleFields(gridFields, flattenFields) {
  return gridFields
    .map((fieldName) =>
      flattenFields.find((item) => {
        return item.name === fieldName;
      })
    )
    .filter((field) => !!field);
}
